import React from 'react';
import { Tabs } from 'antd';
import { TabItem } from 'types/componentTypes/tabs-component-types';
import 'baseComponents/TabsComponent/tabsComponent.scss';

interface Props {
  onChange?: (key: string) => void;
  items: TabItem[];
  defaultActiveKey?: string;
  activeKey?: string;
}

export const TabsComponent: React.FC<Props> = (props) => {
  return (
    <Tabs
      activeKey={props.activeKey}
      defaultActiveKey={props.defaultActiveKey}
      onChange={props.onChange}
      type='card'
      items={props.items}
    />
  );
};
